import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import CustomerListScreen from '../screens/customer/CustomerListScreen';
import CustomerDetailScreen from '../screens/customer/CustomerDetailScreen';
import CustomerFormScreen from '../screens/customer/CustomerFormScreen';
import MeasurementFormScreen from '../screens/measurement/MeasurementFormScreen';
import BodyMeasurementScreen from '../screens/measurement/BodyMeasurementScreen';
import CustomerOrdersScreen from '../screens/customer/CustomerOrdersScreen';
import CustomerDuesScreen from '../screens/customer/CustomerDuesScreen';
import CustomerLedgerScreen from '../screens/customer/CustomerLedgerScreen';

const Stack = createNativeStackNavigator();

const CustomerNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="CustomerList" component={CustomerListScreen} />
      <Stack.Screen name="CustomerDetail" component={CustomerDetailScreen} />
      <Stack.Screen name="CustomerForm" component={CustomerFormScreen} />
      <Stack.Screen name="CustomerOrders" component={CustomerOrdersScreen} />
      <Stack.Screen name="CustomerDues" component={CustomerDuesScreen} />
      <Stack.Screen name="CustomerLedger" component={CustomerLedgerScreen} />
      <Stack.Screen name="MeasurementForm" component={MeasurementFormScreen} />
      <Stack.Screen name="BodyMeasurement" component={BodyMeasurementScreen} />
    </Stack.Navigator>
  );
};

export default CustomerNavigator;
